
import { sagaMiddleware } from '../sagaMiddleware';
import { messageSagas } from './messages/messageSagas';

import { effectDescriptorSagas } from './effects/effectDescriptorSagas';

import { searchEarthquakesSagas } from './earthquakes/search/earthquakeSearchSagas';
import { searchTsunamiEventsSagas } from './tsunamis/event/search/tsunamiEventSearchSagas';
import { searchReferencesSagas } from './references/search/referenceSearchSagas';
import { searchRunupsSagas } from './tsunamis/runups/search/runupSearchSagas';
import { searchDepositsSagas } from './tsunamis/deposits/search/depositSearchSagas';
import { searchMarigramsSagas } from './tsunamis/marigrams/search/marigramSearchSagas';

import { volcanoEventSearchSagas } from './volcanoes/event/search/volcanoEventSearchSagas';
import { volcanoEventInfoSagas } from './volcanoes/event/info/volcanoEventInfoSagas';
import { volcanoEventEditSagas } from './volcanoes/event/edit/volcanoEventEditSagas';
import { volcanoEventDataSagas } from './volcanoes/event/data/volcanoEventDataSagas';

import { volcanoLocationSearchSagas } from './volcanoes/location/search/volcanoLocationSearchSagas';
import { volcanoLocationEditSagas } from './volcanoes/location/edit/volcanoLocationEditSagas';
import { volcanoLocationDataSagas } from './volcanoes/location/data/volcanoLocationDataSagas';

import { earthquakeInfoSagas } from './earthquakes/info/earthquakeInfoSagas';
import { earthquakeEditSagas } from './earthquakes/edit/earthquakeEditSagas';
import { earthquakeDataSagas } from './earthquakes/data/earthquakeDataSagas';

import { tsunamiEventInfoSagas } from './tsunamis/event/info/tsunamiEventInfoSagas';
import { tsunamiEventEditSagas } from './tsunamis/event/edit/tsunamiEventEditSagas';
import { tsunamiEventDataSagas } from './tsunamis/event/data/tsunamiEventDataSagas';

import { referenceInfoSagas } from './references/info/referenceInfoSagas';
import { referenceEditSagas } from './references/edit/referenceEditSagas';
import { referenceDataSagas } from './references/data/referenceDataSagas';

import { runupInfoSagas } from './tsunamis/runups/info/runupInfoSagas';
import { runupEditSagas } from './tsunamis/runups/edit/runupEditSagas';
import { runupDataSagas } from './tsunamis/runups/data/runupDataSagas';

import { marigramInfoSagas } from './tsunamis/marigrams/info/marigramInfoSagas';
import { marigramEditSagas } from './tsunamis/marigrams/edit/marigramEditSagas';
import { marigramDataSagas } from './tsunamis/marigrams/data/marigramDataSagas';

import { depositRelatedTsunamiSagas } from './tsunamis/deposits/related-tsunamis/depositRelatedTsunamisSagas';
import { depositEditSagas } from './tsunamis/deposits/edit/depositEditSagas';

import { relatedRunupSagas } from './tsunamis/event/related-runup/tsunamiRelatedRunupsSagas';
import { relatedDepositsSagas } from './tsunamis/event/related-deposit/tsunamiRelatedDepositsSagas';

import { loginSagas } from './login/loginSagas';


const sagas = [
  ...messageSagas,
  ...effectDescriptorSagas,
  ...earthquakeDataSagas,
  ...earthquakeInfoSagas,
  ...earthquakeEditSagas,
  ...referenceDataSagas,
  ...referenceEditSagas,
  ...referenceInfoSagas,
  ...volcanoEventSearchSagas,
  ...volcanoEventInfoSagas,
  ...volcanoEventEditSagas,
  ...searchEarthquakesSagas,
  ...searchTsunamiEventsSagas,
  ...searchReferencesSagas,
  ...searchRunupsSagas,
  ...searchDepositsSagas,
  ...searchMarigramsSagas,
  ...tsunamiEventDataSagas,
  ...tsunamiEventEditSagas,
  ...tsunamiEventInfoSagas,
  ...runupDataSagas,
  ...runupInfoSagas,
  ...runupEditSagas,
  ...marigramDataSagas,
  ...marigramInfoSagas,
  ...marigramEditSagas,
  ...volcanoLocationSearchSagas,
  ...volcanoLocationDataSagas,
  ...volcanoLocationEditSagas,
  ...volcanoEventDataSagas,
  ...depositRelatedTsunamiSagas,
  ...depositEditSagas,
  ...relatedDepositsSagas,
  ...relatedRunupSagas,
  ...loginSagas,
];

export const runSagas = () => {
  sagas.forEach(sagaMiddleware.run);
};
